import { action } from 'mobx';
import { handleDisconnectTrack } from 'components/LiveClass/utils/disconnect';
import UserMediaStore from './UserMediaStore';

class RemoteUserMediaStore extends UserMediaStore {
  initUserMedia(participant, twilioRoom) {
    super.initUserMedia(participant, twilioRoom);

    this.participant
      .off('trackSubscribed', this.handleTrackSubscribed)
      .on('trackSubscribed', this.handleTrackSubscribed)
      .off('trackUnsubscribed', this.handleTrackUnsubscribed)
      .on('trackUnsubscribed', this.handleTrackUnsubscribed);
  }

  @action
  handleTrackSubscribed = (track, publication) => {
    switch (track.name) {
      case 'video': {
        this.videoPublication = publication;
        this.isVideoEnabled = true;
        break;
      }
      case 'audio': {
        this.audioPublication = publication;
        this.isAudioEnabled = true;
        break;
      }
      case 'screen': {
        this.screenSharePublication = publication;
        this.isScreenShareEnabled = true;
        break;
      }
      default:
        break;
    }
  };

  @action
  handleTrackUnsubscribed = (track, publication) => {
    handleDisconnectTrack(track);
    switch (publication.trackName) {
      case 'video':
        this.isVideoEnabled = false;
        break;
      case 'audio':
        this.isAudioEnabled = false;
        break;
      case 'screen':
        this.isScreenShareEnabled = false;
        break;
      default:
        break;
    }
  };
}

export default RemoteUserMediaStore;
